// extracted by mini-css-extract-plugin
module.exports = {"uk-h5-image-ads":"style_uk-h5-image-ads__yXQED","adsModule":"style_adsModule__L77zC","adsContainer":"style_adsContainer__UW4Nb","adsItem":"style_adsItem__U3AM5"};